import { render, staticRenderFns } from "./StatusCode.vue?vue&type=template&id=46f038c7&scoped=true&"
import script from "./StatusCode.vue?vue&type=script&lang=js&"
export * from "./StatusCode.vue?vue&type=script&lang=js&"
import style0 from "./StatusCode.vue?vue&type=style&index=0&id=46f038c7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46f038c7",
  null
  
)

export default component.exports